import request from '@/utils/request'

/**
 * Accounting Reports API
 * Base URL: /api/v1/accounting/reports
 */

/**
 * Get cash flow statement
 * @param {Object} params - Query parameters
 * @param {string} params.date_from - Start date (YYYY-MM-DD)
 * @param {string} params.date_to - End date (YYYY-MM-DD)
 */
export const getCashFlowStatement = params => request.get('/accounting/reports/cash-flow', { params })

/**
 * Get general ledger
 * @param {Object} params - Query parameters
 * @param {string} params.date_from - Start date (YYYY-MM-DD)
 * @param {string} params.date_to - End date (YYYY-MM-DD)
 */
export const getGeneralLedger = params => request.get('/accounting/reports/general-ledger', { params })

/**
 * Get account statement report
 * @param {number} accountId - Account ID
 * @param {Object} params - Query parameters
 * @param {string} params.date_from - Start date (YYYY-MM-DD)
 * @param {string} params.date_to - End date (YYYY-MM-DD)
 */
export const getAccountStatementReport = (accountId, params = {}) => request.get(`/accounting/reports/account/${accountId}/statement`, { params })
